import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController } from 'ionic-angular';
import { Globals } from "../../../globals";
import { InvoicesServices } from "../../invoices/services";
import { ConfigurationServices } from '../../configuration/services';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Color } from 'ng2-charts';
import { SalesServices } from '../services';
import { DatePipe } from '@angular/common';
import { ChartDataSets, ChartOptions } from 'chart.js';
import { AddonsTriggerVersionProPage } from '../../addons/addons-trigger-version-pro/addons-trigger-version-pro';

/**
 * Generated class for the IncomeExpensesListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-sales-analytics',
  templateUrl: 'sales-analytics.html',
})
export class SalesAnalyticsPage {

  //Charts
  lastTicketsPayedList: any;
  aleatori7customersList: any;
  last7CloseCashHistorial: any;
  total_tickets_sales_today: any = 0;
  salesToday: any = 0;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public invoicesServices: InvoicesServices,
    public configurationServices: ConfigurationServices,
    public http: HttpClient,
    public salesServices: SalesServices,
    private datePipe: DatePipe) {

      if(!this.globals.checkLimitsByLicense('sales','analytics')){
        this.navCtrl.pop();
        this.navCtrl.push(AddonsTriggerVersionProPage);
      } 

  }


  //Sales Details
  public chartSales7Labels = null;
  public chartSales7Data = null;
  public chartSales7Type: string = 'line';
  public chartSales7Options: any = {
    legend: {
      display: false,
      position: 'top',
    },
    responsive: true,
    scales: {
      xAxes: [{
        gridLines: {
          display: false
        }

      }],
      yAxes: [{
        gridLines: {
          display: false
        }
        , ticks: {
          beginAtZero: true
        }
      }]
    },
    maintainAspectRatio: false,
  };
  public lineChartColors: Color[] = [
    {
      // grey
      backgroundColor: 'transparent',
      borderColor: 'orange',
      pointBackgroundColor: 'orange',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(148,159,177,0.8)'
    }
  ];

  //Most Sales Elements
  public chartSalesElementsLabels = [];
  public chartSalesElementsData = [];
  public chartSalesElementsTable = [];
  public chartSalesElementsType: string = 'bar';
  public chartSalesElementsOptions: any = {
    legend: {
      display: false,
      position: 'top',
    },
    scales: {
      yAxes: [{
        ticks: {
          beginAtZero: true
        }
      }]
    }
  };
  public chartElementsColors: Color[] = [
    {

      backgroundColor: 'orange',

    }
  ];

  //elements
  public chartSalesElementLabels = [
    'pollo a la brasa',
    'macarrones a la boloñesa',
    'lacón con cachelos (plato típico de la cocina gallega a base de carne de cerdo y patatas)',
    'dorada a la mediterránea',
    'calabacines rellenos',
    'Calamares'
  ];
  public chartSalesElementData = [10, 35, 24, 16, 31, 29];
  public chartSalesElementType: string = 'bar';
  public chartSalesElementOptions: any = {
    legend: {
      display: false,
      position: 'top',
    },
  };

  //Tickets
  public chartTiketsPerHalfHourLabels = null;
  public chartTiketsPerHalfHourData = null;
  public chartTiketsPerHalfHourType: string = 'bar';
  public chartTiketsPerHalfHourOptions: any = {
    legend: {
      display: false,
      position: 'top',
    },
    maintainAspectRatio: false,
  };
  public chartTiketsChartColors: Color[] = [
    {

      backgroundColor: 'orange',

    }
  ];



  //elements
  public chartSalesRoomsLabels: string[];
  public chartSalesRoomsData = [];
  public chartSalesRoomsType: string = 'doughnut';
  public chartSalesRoomsOptions: any = {
    legend: {
      display: true,
      position: 'top',
    },
  };
  public chartRoomsColors: Color[] = [
    {

      backgroundColor: [
        'orange',
        '#fdbc44',
        '#fdca6b',
        '#fbd58f',
        '#c78f27',
        '#dea63f',
        '#eabf6f'
      ]

    }
  ];

  //
  //Waiter Sales
  public chartWaiterSalesData: ChartDataSets[] = [];
  public chartWaiterSalesLabels: string[] = [];
  public chartWaiterSalesOptions: (ChartOptions & { annotation: any }) = {
    responsive: true,
  };
  public chartWaiterSalesColors: Color[] = [
    {
      borderColor: 'black',
      backgroundColor: 'transparent'
    },
    {
      borderColor: 'red',
      backgroundColor: 'transparent'
    },
    {
      borderColor: 'lime',
      backgroundColor: 'transparent'
    },
    {
      borderColor: 'yellow',
      backgroundColor: 'transparent'
    },
    {
      borderColor: 'orange',
      backgroundColor: 'transparent'
    },
    {
      borderColor: 'blue',
      backgroundColor: 'transparent'
    },
    {
      borderColor: 'blueviolet',
      backgroundColor: 'transparent'
    },
    {
      borderColor: 'grey',
      backgroundColor: 'transparent'
    },
    {
      borderColor: 'olive',
      backgroundColor: 'transparent'
    },
    {
      borderColor: '#3bafda',
      backgroundColor: 'transparent'
    }
  ];
  public chartWaiterSalesLegend = true;
  public chartWaiterSalesType = 'line';

  ionViewWillEnter() {
    this.getAllInfo();
  }

  getAllInfo(){
    this.getSalesDetails();
    this.getMostSalesElements();
    this.getTickets();
    this.getSourceIncome();
    this.getAverageIncome();
    this.getRoomsOccupation();
    this.getWaiterInfo();
  }

  //Dates
  date_first = this.globals.analytics_start_date;
  date_last = this.globals.analytics_finish_date;

  recalculate() {
    this.globals.analytics_start_date = this.date_first;
    this.globals.analytics_finish_date = this.date_last;

    this.navCtrl.pop();
    this.navCtrl.push(SalesAnalyticsPage);

    this.getAllInfo();
  }
  getDays(days) {

    let actual_date = this.globals.dateTimeNow(); //Get actual date
    actual_date = this.datePipe.transform(actual_date, 'yyyy-MM-dd'); //Format date
    this.date_last = actual_date; //The last day is the actual day
    this.date_first = this.globals.getLastDays(actual_date, days - 1); //The first dat is the actual day less number of days

    this.globals.analytics_start_date = this.date_first;
    this.globals.analytics_finish_date = this.date_last;

    this.navCtrl.pop();
    this.navCtrl.push(SalesAnalyticsPage);

    this.getAllInfo();
  }

  salesDetail: any;
  salesDetailTotal: any;
  salesDetailAverage: any;

  mostSalesElements: any;

  tickets: any;
  ticketTotal: any;
  ticketAverageDay: any;
  ticketMaxHour: any;
  ticketMinHour: any;
  ticketTable: any;

  sourceIncome: any;

  averageIncome: any;
  averageIncomeAverage: any;
  averageIncomeAverageTime: any;
  averageIncomeZone: any;
  averageIncomeZoneEffective: any;
  averageIncomeZoneEffectiveValue: any;

  async getSalesDetails() {

    //Obtenemos la informacion de facturacion del restaurante

    /*const body = new HttpParams()
      .set('uid', this.globals.restaurant_uid)
      .set('first_day', this.globals.analytics_start_date)
      .set('last_day', this.globals.analytics_finish_date);*/

    await this.http.post(this.globals.analytics_path + 'sales-details/' + this.globals.restaurant_uid + '/' + this.globals.analytics_start_date
      + '/' + this.globals.analytics_finish_date, {}).subscribe(async data => {
        this.salesDetail = data;


        this.salesDetailTotal = this.salesDetail[0]['total'];
        this.salesDetailAverage = this.salesDetail[0]['average'];
        this.chartSales7Labels = this.salesDetail[0]['labels'];
        this.chartSales7Data = this.salesDetail[0]['data'];
      },
        err => {

        }
      );
  }
  async getMostSalesElements() {

    //Obtenemos la informacion de elementos mas vendidos del restaurante

    /*const body = new HttpParams()
      .set('uid', this.globals.restaurant_uid)
      .set('first_day', this.globals.analytics_start_date)
      .set('last_day', this.globals.analytics_finish_date);*/

    await this.http.post(this.globals.analytics_path + 'most-sales-elements/'
      + this.globals.restaurant_uid + '/'
      + this.globals.analytics_start_date + '/'
      + this.globals.analytics_finish_date, {}).subscribe(async data => {

        this.mostSalesElements = data;
        this.chartSalesElementsData = this.mostSalesElements['data'].slice(0, 25);
        this.chartSalesElementsLabels = this.mostSalesElements['label'].slice(0, 25);
        this.chartSalesElementsTable = this.mostSalesElements['table'];
      },
        err => {
        }
      );
  }
  async getTickets() {

    //Obtenemos la informacion de los tickets del restaurante

    /*const body = new HttpParams()
      .set('uid', this.globals.restaurant_uid)
      .set('first_day', this.globals.analytics_start_date)
      .set('last_day', this.globals.analytics_finish_date);*/

    await this.http.post(this.globals.analytics_path + 'tickets/' + this.globals.restaurant_uid + '/' + this.globals.analytics_start_date
      + '/' + this.globals.analytics_finish_date, {}).subscribe(async data => {
        this.tickets = data;

        this.ticketTotal = this.tickets['graphic']['total'];
        this.ticketAverageDay = this.tickets['graphic']['average_day'].toFixed(2);
        this.ticketMaxHour = this.tickets['graphic']['max_hour'];
        this.ticketMinHour = this.tickets['graphic']['min_hour'];
        this.ticketTable = this.tickets['table'];

        this.chartTiketsPerHalfHourLabels = this.tickets['labels'];
        this.chartTiketsPerHalfHourData = this.tickets['data'];

      },
        err => {
        }
      );
  }


  //fonts ingres
  public chartTypeIncomesLabels: string[];
  public chartTypeIncomesData = [];
  public chartTypeIncomesType = 'doughnut';
  public chartTypeIncomesOptions = {
    legend: {
      display: false,
      position: 'left',
    }
  };
  public chartTypeIncomesColor: Color[] = [
    {

      backgroundColor: [
        'orange',
        '#fdbc44',
        '#fdca6b',
        '#fbd58f',
        '#c78f27',
        '#dea63f',
        '#eabf6f'
      ]

    }
  ];

  checkSourceIncome = false;
  async getSourceIncome() {

    //Obtenemos la informacion de ingresos del restaurante

    /*const body = new HttpParams()
      .set('uid', this.globals.restaurant_uid)
      .set('first_day', this.globals.analytics_start_date)
      .set('last_day', this.globals.analytics_finish_date);*/

    await this.http.post(this.globals.analytics_path + 'source-income/' + this.globals.restaurant_uid + '/' + this.globals.analytics_start_date
      + '/' + this.globals.analytics_finish_date, {}).subscribe(async data => {
        this.sourceIncome = data;        
        
        this.chartTypeIncomesData = this.sourceIncome['data'];
        this.chartTypeIncomesLabels = this.sourceIncome['labels'];
        this.checkSourceIncome = true;
        let totalTypeIcomes = parseFloat(this.chartTypeIncomesData[0]) + parseFloat(this.chartTypeIncomesData[1]) + parseFloat(this.chartTypeIncomesData[2]);
        this.chartTypeIncomesData.push(String(totalTypeIcomes));

      },
        err => {
        }
      );
  }
  averageIncomeZoneEffectiveMediaFacturacion: any;
  async getAverageIncome() {

    //Obtenemos la informacion de medias del restaurante

    /*const body = new HttpParams()
      .set('uid', this.globals.restaurant_uid)
      .set('first_day', this.globals.analytics_start_date)
      .set('last_day', this.globals.analytics_finish_date);*/

    await this.http.post(this.globals.analytics_path + 'average-income/' + this.globals.restaurant_uid + '/' + this.globals.analytics_start_date
      + '/' + this.globals.analytics_finish_date, {}).subscribe(async data => {
        this.averageIncome = data;

        this.averageIncomeAverage = this.averageIncome['table']['average'];
        this.averageIncomeAverageTime = this.averageIncome['table']['average_time'];
        this.averageIncomeZone = this.averageIncome['table']['zone_more_tickets'];
        this.averageIncomeZoneEffective = this.averageIncome['table']['zone_effective'];
        this.averageIncomeZoneEffectiveValue = this.averageIncome['table']['zone_effective_value'];
        this.averageIncomeZoneEffectiveMediaFacturacion = this.averageIncomeZoneEffectiveValue / this.averageIncome['table']['tickets_zone_more_tickets'];

      },
        err => {
        }
      );
  }

  salesRoom_array: any;
  checkSalesRoom = false;
  async getRoomsOccupation() {
    const body = new HttpParams()
      .set('uid', this.globals.restaurant_uid)
      .set('first_day', this.globals.analytics_start_date)
      .set('last_day', this.globals.analytics_finish_date);

    await this.http.post(this.globals.analytics_path + 'get-rooms-occupation', body).subscribe(async data => {

      this.chartSalesRoomsData = data['data'];
      this.chartSalesRoomsLabels = data['labels'];
      this.salesRoom_array = data['table_rooms'];
      this.checkSalesRoom = true;
    },
      err => {
      });
  }

  waiters_array: any;
  async getWaiterInfo() {
    const body = new HttpParams()
      .set('uid', this.globals.restaurant_uid)
      .set('first_day', this.globals.analytics_start_date)
      .set('last_day', this.globals.analytics_finish_date);

    await this.http.post(this.globals.analytics_path + 'get-waiter-movements', body).subscribe(async data => {

      this.waiters_array = data['user_data'];
      this.chartWaiterSalesLabels = data['days'];
      this.waiters_array.forEach((item, index) => {

        let data_graph = { data: data['data'][index]['moviments_day'], label: data['labels'][index] }

        this.chartWaiterSalesData.push(data_graph);
      });
    },
      err => {
      });
  }
}





// WEBPACK FOOTER //
// ./src/pages/sales/sales-analytics/sales-analytics.ts